import { observer } from "mobx-react";
import React, {useContext, useEffect, useState} from "react";
import OrderSettingsPageStoreContext from "../context";
import { FormControl, Paper, Typography } from "../../../../../common/components/libs";
import {Box, FormControlLabel, InputLabel, Radio, RadioGroup, Switch} from "@material-ui/core";
import Input from "@material-ui/core/Input";
import { changeCheckboxEventHandlerDecorator, changeEventHandlerDecorator } from "../../../../../common/libs";
import UploadImageField from "../../../../../common/components/UploadImageField/UploadImageField";
import { ImageAspectRatio } from "../../../../../common/components/ImageCropperForm";
import { CategoryListPhotosMode, MenuItemsPhotosModes, ThemesIds } from "../../../../../services/menu/models";
import { PaymentProviderType } from "../../../../../services/general/models";
import { useTranslation } from "react-i18next";
import ChooseColorForm from '../components/ChooseColorForm';


const categoriesMode = [
    {
        title: "С фотографиями",
        type: CategoryListPhotosMode.defaultWithPhotos
    },
    {
        title: "Без фотографий",
        type: CategoryListPhotosMode.defaultNoPhotos
    }
];

const menuItemsMode = [
    {
        title: "С фотографиями",
        type: MenuItemsPhotosModes.defaultWithPhotos
    },
    // {
    //     title: "Карточки с вертикальными фотографиями",
    //     type: MenuItemsPhotosModes.verticalWithPhotos
    // },
    {
        title: "Без фотографий",
        type: MenuItemsPhotosModes.defaultNoPhotos
    }
];

const themeMode = [
    {
        title: "Красные кнопки",
        type: ThemesIds.default
    },
    {
        title: "Черные кнопки",
        type: ThemesIds.expensiveBlack
    }
];


const MenuUISettingsBlock = () => {
    const {t} = useTranslation(["general", "menu"]);
    const store = useContext(OrderSettingsPageStoreContext);

    const [currentColor, setCurrentColor] = useState<string | null>(null)
    const [currentField, setCurrentField] = useState<'categoriesBackgroundColor' | 'buttonsBackgroundColor' | null>(null)

    return <>
        <Typography variant={"h3"} mt={20} mb={2}>
            {t("menu:orderSettingsPage.decor")}
        </Typography>
        <Paper p={5} style={{ maxWidth: 800, width: "100%" }}>
            <Typography variant={"h6"} mb={2}>
                {t("menu:orderSettingsPage.cover")}
            </Typography>
            <div>
                <UploadImageField
                    img={store.photos.backgroundPhotoUrl}
                    setPhotoUrl={store.setBackgroundPhotoUrl.bind(store)}
                    aspectRation={ImageAspectRatio.rectangle_3_2}
                />
            </div>

            <Typography variant={"h6"} mt={5} mb={2}>
                {t("menu:orderSettingsPage.logo")}
            </Typography>
            <div >
                <UploadImageField
                    img={store.photos.logoPhotoUrl}
                    setPhotoUrl={store.setLogoUrl.bind(store)}
                    aspectRation={ImageAspectRatio.rectangle_2_2}
                />
            </div>


            <Typography variant={"h6"} mt={5} mb={2}>
                Оформление
            </Typography>
            <FormControl>
                <Box css={{display: 'flex', flexDirection: 'row'}}>
                    <Box style={{
                        display: 'flex',
                        padding: '5px',
                        background: '#fff',
                        borderRadius: '1px',
                        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                        cursor: 'pointer',
                        width: 50
                    }}
                    onClick={() => {
                        setCurrentColor(store.buttonsBackgroundColor)
                        setCurrentField('buttonsBackgroundColor')
                        store.openChooseColorForm()
                    }}
                    >
                        <Box style={{
                            width: '100%',
                            height: '100%',
                            borderRadius: '2px',
                            background: store.buttonsBackgroundColor,
                        }}/>
                    </Box>
                    <Typography variant={'subtitle1'} ml={5}>
                        Цвет кнопок
                    </Typography>
                </Box>
                <Box css={{display: 'flex', flexDirection: 'row', marginTop: 15}}>
                    <Box style={{
                        display: 'flex',
                        padding: '5px',
                        background: '#fff',
                        borderRadius: '1px',
                        boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                        cursor: 'pointer',
                        width: 50
                    }}
                     onClick={() => {
                         setCurrentColor(store.categoriesBackgroundColor)
                         setCurrentField('categoriesBackgroundColor')
                         store.openChooseColorForm()
                     }}
                    >
                        <Box style={{
                            width: '100%',
                            height: '100%',
                            borderRadius: '2px',
                            background: store.categoriesBackgroundColor,
                        }}/>
                    </Box>
                    <Typography variant={'subtitle1'} ml={5}>
                        Цвет категорий
                    </Typography>
                </Box>
            </FormControl>

            <Typography variant={"h6"} mt={5} mb={2}>
                {t("menu:orderSettingsPage.displayingCategories")}
            </Typography>
            <FormControl>
                <RadioGroup value={store.categoryListPhotosMode}>
                    {
                        categoriesMode.map(item => {
                            return <FormControlLabel
                                value={item.type}
                                key={item.type}
                                control={<Radio/>}
                                label={t(`menu:orderSettingsPage.categoriesMode.${item.type}.title`)}
                                onChange={changeEventHandlerDecorator(store.setCategoriesPhotosMode.bind(store))}
                            />
                        })
                    }
                </RadioGroup>
            </FormControl>

            <Typography variant={"h6"} mt={5} mb={2}>
                {t("menu:orderSettingsPage.displayingPositions")}
            </Typography>
            <FormControl>
                <RadioGroup value={store.menuItemsPhotosMode}>
                    {
                        menuItemsMode.map(item => {
                            return <FormControlLabel
                                value={item.type}
                                key={item.type}
                                control={<Radio/>}
                                label={t(`menu:orderSettingsPage.menuItemsMode.${item.type}.title`)}
                                onChange={changeEventHandlerDecorator(store.setMenuItemsMode.bind(store))}
                            />
                        })
                    }
                </RadioGroup>
            </FormControl>
        </Paper>
        {currentField && <ChooseColorForm current={currentColor} field={currentField}/>}
    </>

}


export default observer(MenuUISettingsBlock)
